/* unplugin-vue-components disabled */import script from "./menuPermissions.vue?vue&type=script&setup=true&lang=js"
export * from "./menuPermissions.vue?vue&type=script&setup=true&lang=js"

import "./menuPermissions.vue?vue&type=style&index=0&id=261a4e6c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-261a4e6c"]])

export default __exports__